/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/university_open': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M7 8h18v1H7zM12 13h8v8h-8zM24 11v4h-1v-4h1m1-1h-3v6h3v-6zM12 10h8v2h-8zM4.5 32H0v-4.5h1V31h3.5zM32 32h-4.5v-1H31v-3.5h1zM32 4.5h-1V1h-3.5V0H32zM1 4.5H0V0h4.5v1H1z"/>'
  }
})
